import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Grid, GridColumn, Toggle } from 'telia-front-react';

import InvoiceDetailsStore from '../../../stores/InvoiceDetailsStore';
import { InvoicePaymentStore } from '../../../stores/InvoicePaymentStore';
import InvoicePriceStore from '../../../stores/InvoicePriceStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import InvoiceDetailsFooterViewStore from '../../../stores/view/InvoiceDetailsFooterViewStore';
import { formatAsCurrency } from '../../../util/FormatUtil';
import ButtonWithAnalytics from '../../common/ButtonWithAnalytics';

interface IInvoiceDetailsFooterProps {
  invoiceDetailsFooterViewStore?: InvoiceDetailsFooterViewStore;
  invoiceDetailsStore?: InvoiceDetailsStore;
  invoicePaymentStore?: InvoicePaymentStore;
  invoicePriceStore?: InvoicePriceStore;
  translateStore?: ITranslateStore;
}

@inject('invoiceDetailsFooterViewStore', 'invoiceDetailsStore', 'invoicePaymentStore', 'invoicePriceStore', 'translateStore')
@observer
export default class InvoiceDetailsFooter extends React.Component<IInvoiceDetailsFooterProps> {
  constructor(props: IInvoiceDetailsFooterProps) {
    super(props);
  }

  public render(): JSX.Element {
    const showPaymentButton = this.props.invoiceDetailsFooterViewStore.showPaymentButton;
    const translate = this.props.translateStore.translate;

    return (
      <React.Fragment>
        <Grid align={showPaymentButton ? ['middle-xs', 'between-sm', 'end-md'] : ['middle-xs', 'end-xs']}>
          <GridColumn width={showPaymentButton ? ['xs-5', 'min-sm'] : ['max-xs']}>
            <Grid reverse={showPaymentButton ? ['md'] : ['xs']} verticalGutter="xsmall" align={['middle-xs']}>
              <GridColumn width={showPaymentButton ? ['max-xs', 'min-md'] : ['min-xs']}>{this.paymentAmounts()}</GridColumn>
              <GridColumn width={showPaymentButton ? ['max-xs', 'min-md'] : ['min-xs']}>
                <Toggle
                  label={translate('shared.invoice-details-modal.total-sum-toggle')}
                  id="invoice-details-amount-vat-toggle"
                  defaultChecked={this.props.invoicePriceStore.showPriceWithVat}
                  onChange={(value) => this.props.invoicePriceStore.toggleShowPriceWithVat(value)}
                />
              </GridColumn>
            </Grid>
          </GridColumn>
          {showPaymentButton && (
            <GridColumn width={['xs-7', 'min-sm']} align={['middle-xs']} className="text-right">
              {this.paymentButton()}
            </GridColumn>
          )}
        </Grid>
      </React.Fragment>
    );
  }

  private paymentAmounts(): JSX.Element {
    const { invoiceTotalWoVat, invoiceTotalSum } = this.props.invoiceDetailsStore.invoiceDetails.payload.details.invoiceFooter;
    const { showPriceWithoutVat } = this.props.invoicePriceStore;

    return showPriceWithoutVat ? (
      <p id="total-sum-without-vat" className="text-bold h3">
        {formatAsCurrency(invoiceTotalWoVat)}
      </p>
    ) : (
      <p id="total-sum-with-vat" className="c-brand-primary-text text-bold h3">
        {formatAsCurrency(invoiceTotalSum)}
      </p>
    );
  }

  private paymentButton(): JSX.Element {
    const invoiceDetailsRequest = this.props.invoiceDetailsStore.invoiceDetailsRequest;
    const invoiceNumber = invoiceDetailsRequest.invoiceNumber;
    const translate = this.props.translateStore.translate;

    return (
      <ButtonWithAnalytics
        gaEvent="CTA - pay invoice"
        buttonProps={{
          id: 'invoice-details-modal-pay-button',
          text: translate('shared.invoice-details-modal.pay'),
          iconRight: '#arrow-right',
          onClick: () => this.props.invoicePaymentStore.makePayment(invoiceNumber)
        }}
      />
    );
  }
}
